import React, { createContext } from 'react';

const MaskContext = createContext({});

export default MaskContext;